import dayjs from 'dayjs'
import cloneDeep from 'lodash.clonedeep'

export default {
    minutesToTime(minutes) {
        return dayjs().utcOffset(0).startOf('day').add(minutes, 'minutes').format('HH:mm')
    },

    minutesDateToLocalTZTime(minutes, date, timeZone) {
        return dayjs.utc(date).startOf('day').add(minutes, 'm').tz(timeZone).format('HH:mm')
    },

    timelineMinutesLocalToMinutesUTC(minutesSlots, timeZone) {
        const utcOffset = dayjs().tz(timeZone).utcOffset()
        const slots = cloneDeep(minutesSlots)

        Object.keys(slots).forEach((day) => {
            slots[day] = slots[day].map((slot) => ({ from: slot.from - utcOffset, to: slot.to - utcOffset }))
        })
        return slots
    },

    minutesDateToUTCOffset(hours, minutes, timeZone, date) {
        const utcOffset = dayjs(date).tz(timeZone).utcOffset()
        const totalMinutes = hours * 60 + minutes
        return totalMinutes - utcOffset
    },

    timelineMinutesUTCToMinutesLocal(minutesSlots, timeZone) {
        const utcOffset = dayjs().tz(timeZone).utcOffset()
        const slots = cloneDeep(minutesSlots)

        Object.keys(slots).forEach((day) => {
            slots[day] = slots[day].map((slot) => ({ from: slot.from + utcOffset, to: slot.to + utcOffset }))
        })
        return slots
    },

    timelineMinutesUTCToTimeLocal(minutesSlots, date, timeZone) {
        const slots = cloneDeep(minutesSlots)

        Object.keys(slots).forEach((day) => {
            slots[day] = slots[day].map((slot) => ({
                from: this.minutesDateToLocalTZTime(slot.from, date, timeZone),
                to: this.minutesDateToLocalTZTime(slot.to, date, timeZone),
            }))
        })
        return slots
    },
}
